
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as Model } from '../../controlador';
    import { Controlador as ControladorBusqueda } from '../../controlador-cursos';
    import buscador from './cursos-lista-buscador.vue';
    import filtros from './cursos-filtros.vue';
    import opciones from './cursos-opciones.vue';
    import paginacion from './cursos-paginacion.vue';
    import { Pedido } from '@/__env/lib/Ventas/Pedidos';
    import { DataTableHeader } from 'vuetify';
    import { Curso } from '@/__env/lib/Cursos';
    import * as  Cursos from '@/__env/lib/Cursos';
    import { Utiles } from '@/__env/pluggins/event-bus';

    @Component( {
        name: "Componente",
        props: {},
        components: {
            buscador,
            filtros,
            opciones,
            paginacion,
        }
    } )
    export default class Componente extends Vue
    {
        public get ControladorPrincipal() { return Model; }
        public get Controlador() { return ControladorBusqueda; }
        public get Buscador() { return ControladorBusqueda.Buscador; }

        public Estado: string = '';

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }
        async mounted()
        {
            this.Estado = this.Buscador.Estado;
            this.Eventos.push( this.Buscador.onEstado.subscribe( () => this.Estado = this.Buscador.Estado ) );
            this.Eventos.push( this.Buscador.onActualizar.subscribe( () =>
            {
                this.Items = this.Buscador.Items;
                this.$EventBus.setQuery( this.Buscador.Filtros.get() );
            } ) );

            this.Controlador.Iniciar();
            this.Buscador.Filtros.set( this.$route.query );
            this.Buscador.Filtros.Valores.Tipo = this.Buscador.Filtros.Tipos.findIndex( x => x.Valor.findIndex( a => a.Id == this.ControladorPrincipal.Vista.Modo ) != -1 );
            await this.Buscador.Buscar();

        }

        public Seleccionados: Array<Pedido> = [];
        @Watch( 'Seleccionados', { immediate: true } )
        onSeleccionados()
        {
            //this.Controlador.editarSeleccionados( this.Seleccionados );
        }

        public Items: Array<Curso> = [];
        public Headers: Array<DataTableHeader> = [
            { text: '#', align: 'start', value: 'Col1', },
            { text: 'Curso', align: 'start', value: 'Titulo' },
            { text: 'Estado', align: 'center', value: 'Col2' },
            { text: 'Preguntas', align: 'center', value: 'Preguntas.length' },
            { text: 'Fecha', align: 'center', value: 'Col3' },
            { text: '', align: 'end', value: 'Col4' },
        ];

        Abrir( item: Curso )
        {
            if ( item.Estado.esCreado )
            {
                this.ControladorPrincipal.Editar( item );
            } else
            {
                this.ControladorPrincipal.Abrir( item );
            }
        }

        async Activar( item: Curso )
        {
            if ( await Utiles.Mensajes.SiNo( '¿Activar el curso?', 'Los usuarios podran tomar el curso. Ten en cuenta que no podrás editarlo.' ) )
            {
                let e = await item.ModificarEstado( Cursos.Estados.Activo );
                if ( e )
                {
                    this.$EventBus.Notificaciones.Completado( 'Guardado correctamente' );
                    this.ControladorPrincipal.Abrir( item );
                }
                else
                {
                    this.$EventBus.Notificaciones.Error( 'Error al guardar' );
                }
            }
        }
    }
